"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=require("./index33.js");var t=l.isCallable,a=function(e){return typeof e=="object"?e!==null:t(e)};exports.isObject=a;
